import { enqueueSnackbar } from "notistack";
import { useCallback, useState } from "react";

import { ApiConfig } from "./api-config";
import { request } from "./index";
import { RequestParams } from "./request-options";

interface UseRequestOptions<T = null> {
  api: ApiConfig;

  title?: string;

  defaultData?: T;
}

export function useRequest<T, D = RequestParams>(config: UseRequestOptions<T>) {
  const [data, setData] = useState<T | undefined>(config.defaultData);
  const [isLoading, setIsLoading] = useState(false);

  const requestHandler = useCallback(
    async (options?: { param: D; onSuccess?: (result: T) => void }) => {
      setIsLoading(true);

      const r = await request<T>({
        api: config.api,
        params: options?.param,
      });

      if (r.success) {
        setData(r.data);

        if (options?.onSuccess) {
          options.onSuccess(r.data);
        }
      } else {
        let msg = "数据请求失败";
        if (config.title) {
          msg += `[${config.title}]`;
        }
        msg += `: ${r.message}`;

        enqueueSnackbar(msg, { variant: "warning" });
      }

      setTimeout(() => {
        setIsLoading(false);
      }, 300);
    },
    [config.api, config.title],
  );

  return { data, requestHandler, isLoading };
}
